module.exports = __webpack_public_path__ + "img/mount_reginato.f192f2c2.jpg";